import { apiFetch } from "./client";

export function getAlertsConfig() {
  return apiFetch("/api/admin/alerts/config");
}

export function saveAlertSettings(patch) {
  return apiFetch("/api/admin/alerts/settings", { method: "PUT", body: patch });
}

export function subscribeDevice(subscription) {
  return apiFetch("/api/admin/alerts/subscribe", { method: "POST", body: subscription });
}

export function unsubscribeDevice(endpoint) {
  return apiFetch("/api/admin/alerts/unsubscribe", { method: "POST", body: { endpoint } });
}

export function sendTestAlert() {
  return apiFetch("/api/admin/alerts/test", { method: "POST", body: {} });
}

export function getRecentAlerts() {
  return apiFetch("/api/admin/alerts/recent");
}

/** A one-time code that signs another device in as you (10 minutes, single use). */
export function createPairCode() {
  return apiFetch("/api/admin/devices/pair-code", { method: "POST", body: {} });
}

export function redeemPairCode(code) {
  return apiFetch("/api/public/devices/pair", { method: "POST", body: { code } });
}

/** Tell the server a screen crashed. Best-effort: never throws. */
export async function reportClientError({ where, message, token }) {
  try {
    await apiFetch("/api/public/client-error", {
      method: "POST",
      body: { where, message: String(message || "").slice(0, 400), token: token || undefined },
    });
  } catch {
    /* nothing more we can do */
  }
}
